import { render, staticRenderFns } from "./RoomMenuBtn_comp.vue?vue&type=template&id=4b4f058b&scoped=true&"
import script from "./RoomMenuBtn_comp.vue?vue&type=script&lang=js&"
export * from "./RoomMenuBtn_comp.vue?vue&type=script&lang=js&"
import style0 from "./RoomMenuBtn_comp.vue?vue&type=style&index=0&id=4b4f058b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4f058b",
  null
  
)

export default component.exports